import PropTypes from 'prop-types';
import {Component} from 'react';
import {Tab} from 'semantic-ui-react';
import CustomiseCoverPageImagesTabContentContainer from './CustomiseCoverPageImagesTabContentContainer';

class CustomiseCoverPageImagesTabWrapper extends Component {

  static propTypes = {
    selectedImage: PropTypes.shape({
      src: PropTypes.string,
      type: PropTypes.string,
      zoom: PropTypes.number,
      x: PropTypes.number,
      y: PropTypes.number,
    }).isRequired,
    onSelection: PropTypes.func.isRequired,
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      activeTabIndex: 0,
    };
  }

  componentDidMount() {
    const {selectedImage: {type}} = this.props;
    let activeTabIndex;
    if (type === 'property') {
      activeTabIndex = 1;
    } else {
      activeTabIndex = 0;
    }
    this.setState({'activeTabIndex': activeTabIndex});
  }

  tabChange = (e, {activeIndex}) => {
    this.setState({'activeTabIndex': activeIndex});
  };

  render() {
    const {activeTabIndex} = this.state;
    const {onSelection, selectedImage} = this.props;
    const renderPane = ({type}) => () => {
      return (
        <Tab.Pane attached={false}>
          <CustomiseCoverPageImagesTabContentContainer type={type} selectedImage={selectedImage} onSelection={onSelection}/>
        </Tab.Pane>
      );
    };

    const panes = [
      {menuItem: 'Lifestyle', render: renderPane({type: 'lifestyle'})},
      {menuItem: 'Property', render: renderPane({type: 'property'})},
    ];

    return (
      <Tab menu={{ attached: false, tabular: false, widths: 6 }} panes={panes} activeIndex={activeTabIndex} onTabChange={this.tabChange}/>
    );
  }
}

export default CustomiseCoverPageImagesTabWrapper;
